export const actionsBarSx = {
  borderRadius: 2,
  py: 2,
  pr: 0,
  mt: 2,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 1,
};